<script setup lang="ts">
import { BaseButton } from '@magma-app/magma-lapilli';

import type { SlideOverStatusHelperRole } from './types';

defineProps<{
  statusHelperRole: SlideOverStatusHelperRole;
  modalText: {
    title: string;
    description: string;
  };
  displaySuccessView: boolean;
}>();

const emit = defineEmits<{
  (event: 'showDeactivateForm'): void;
  (event: 'showReactivateForm'): void;
  (event: 'cancel'): void;
  (event: 'close'): void;
}>();
</script>

<template>
  <div>
    <p class="text-center">
      <span class="block text-mgm-txt-md font-medium text-foreground-emphasis">
        {{ modalText.title }}
      </span>

      <span
        class="mt-2 block text-mgm-txt-sm font-normal text-foreground-default"
      >
        {{ modalText.description }}
      </span>
    </p>

    <template
      v-if="
        ['deactivate-campaign', 'reactivate-campaign'].includes(
          statusHelperRole
        ) && !displaySuccessView
      "
    >
      <BaseButton
        v-if="statusHelperRole === 'reactivate-campaign'"
        class="mt-6 w-full"
        :text="$t('slideOverModal.reactivate.cta')"
        size="md"
        @click="emit('showReactivateForm')"
      />

      <BaseButton
        v-else-if="statusHelperRole === 'deactivate-campaign'"
        class="mt-6 w-full"
        :text="$t('slideOverModal.deactivate.cta')"
        size="md"
        @click="emit('showDeactivateForm')"
      />

      <BaseButton
        class="mt-2 w-full"
        :text="$t('generic.cancel')"
        size="md"
        state="scdr"
        @click="emit('cancel')"
      />
    </template>

    <BaseButton
      v-else-if="
        statusHelperRole === 'join-campaign' ||
        (['deactivate-campaign', 'reactivate-campaign'].includes(
          statusHelperRole
        ) &&
          displaySuccessView)
      "
      class="mt-6 w-full"
      :text="$t('generic.getIt')"
      size="md"
      @click="emit('close')"
    />
  </div>
</template>
